var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g({staticClass:"select__footer-create-link"},_vm.$listeners),[_c('i',{staticClass:"select__footer-create-icon iconoir-selection"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('addElementButton.label'))+" ")]),_vm._v(" "),_c('i',{staticClass:"select__footer-create-link-icon iconoir-plus"})])
}
var staticRenderFns = []

export { render, staticRenderFns }